import React from 'react';
import { Chip } from '@mui/material';

/**
 * Status chip display with color coding
 */
export const StatusTemplate: React.FC<{ status: string }> = ({ status }) => {
  const getStatusColor = (status: string): 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info' => {
    switch (status?.toUpperCase()) {
      case 'OPEN':
        return 'primary';
      case 'CLOSED':
        return 'success';
      case 'PENDING':
        return 'warning';
      case 'CANCELLED':
        return 'error';
      default:
        return 'default';
    }
  };

  return (
    <Chip
      label={status || 'Unknown'}
      color={getStatusColor(status)}
      size="small"
      sx={{ minWidth: 80 }}
    />
  );
};

export default StatusTemplate;
